import { useModal } from "@/Contexts";
import ModalContainer from "@/components/modalContainer";
import { useTrans } from "@/translations";

import { useState } from "react";

import { useAccessPoints } from "../manage/useAccessPoints";

export const DeletePointModal: React.FC<{
  accessParentId: string;
  pointId: string;
  pointName: string | undefined;
  deleteFunction: (
    payload: { id: string },
    callbacks: { onSuccess: () => void; onError: () => void },
  ) => void;
  onSuccess?: () => void;
  modalTitle: string;
}> = ({
  accessParentId,
  pointId,
  pointName,
  deleteFunction,
  onSuccess,
  modalTitle,
}) => {
  const [isLoading, setLoading] = useState(false);

  const { t } = useTrans();
  const { hideModal } = useModal();
  const { refetchAll } = useAccessPoints({ accessParentId });

  const onFailCallBack = () => {
    setLoading(false);
  };

  const onSuccessCallback = () => {
    hideModal();
    refetchAll();
    onSuccess?.();
  };

  const onConfirm = () => {
    setLoading(true);

    deleteFunction(
      { id: pointId },
      {
        onSuccess: onSuccessCallback,
        onError: onFailCallBack,
      },
    );
  };

  return (
    <ModalContainer
      title={modalTitle}
      onConfirmText={"actions:confirm"}
      onConfirm={onConfirm}
      onCancel={hideModal}
      onConfirmLoading={isLoading}
      onConfirmDisabled={isLoading}
    >
      <div className="pt-3">
        <p>{t("hints:areYouSureDelete", { name: pointName })}</p>
      </div>
    </ModalContainer>
  );
};
